function getCumulativeWaitingTimesPerGroup(currMetric, resourceGroups) {
    var cumulativeWaitingTimes = [];
    resourceGroups.forEach((group1) => {
        resourceGroups.forEach((group2) => {
            var val1 = currMetric.cumulativeWaitingTimesPerGroup[group1.id][group2.id];
            var val2 = currMetric.cumulativeWaitingTimesPerGroup[group2.id][group1.id];

            var val = Math.max(val1, val2);
            cumulativeWaitingTimes.push({ group1, group2, val });
        });
    });

    var maxWaitingTime = Math.max(...cumulativeWaitingTimes.map((o) => o.val));
    var minWaitingTime = Math.min(...cumulativeWaitingTimes.map((o) => o.val));

    var minThreshold = 0;
    var maxThreshold = Math.max(200, maxWaitingTime);

    return { cumulativeWaitingTimes, min: minWaitingTime, max: maxWaitingTime, minThreshold: minThreshold, maxThreshold: maxThreshold };
}

// function getRelativeCumulativeMetrics(group1ID, group2ID) {
//     var numDaysAgo = Math.max(0, this.slider - this.numLastDays * 8);
//     var metricsNumDaysAgo = this.$store.state.simulator.performanceTracker.metrics[numDaysAgo];

//     return metrics.cumulativeWaitingTimesPerGroup[group1ID][group2ID] - metricsNumDaysAgo.cumulativeWaitingTimesPerGroup[group1ID][group2ID];
// }

function getMinMaxWaitingTime(metrics) {
    var minVal = metrics[0].waitingTime.B;
    var maxVal = metrics[0].waitingTime.B;

    // Foreach waitingTime in the metric, get the min and max
    metrics.forEach((currMetric) => {
        var waitingTime = currMetric.waitingTime;
        waitingTime["G"] = 0;
        //Get the min and max of waitingTime
        var maxWaitingTime = Math.max(...Object.values(waitingTime));
        var minWaitingTime = Math.min(...Object.values(waitingTime));

        minVal = Math.max(minVal, minWaitingTime);
        maxVal = Math.max(maxVal, maxWaitingTime);
    });

    return { min: minVal, max: maxVal };
}


export { getCumulativeWaitingTimesPerGroup, getMinMaxWaitingTime};

